import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { ShiftAssignmentTags } from '@wilson/interfaces';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'wilson-user-timeline-tags',
  templateUrl: './user-timeline-tags.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslatePipe, FeatureFlagsModule, NzTagModule],
})
export class UserTimelineTagsComponent {
  @Input() tags: ShiftAssignmentTags[] | null = [];
  public ShiftAssignmentTags = ShiftAssignmentTags;
}
